import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets.v2/images/link-icon.svg'


const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "learn-more-item__link" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_4 = {
  key: 1,
  class: "iconfont ilink"
}
const _hoisted_5 = { class: "learn-more-item__description" }
const _hoisted_6 = { class: "learn-more-item__title" }
const _hoisted_7 = { class: "learn-more-item__snippet" }

import type { LearnMoreItem } from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'LearnMoreItem',
  props: {
    item: {},
    isPublicPage: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    class: "learn-more-item",
    href: __props.item?.url
  }, [
    _createElementVNode("div", _hoisted_2, [
      (__props.isPublicPage)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_openBlock(), _createElementBlock("span", _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.item.name), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(__props.item.snippet), 1)
    ])
  ], 8, _hoisted_1))
}
}

})